export default {
      id: "icon-user-edit-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-user-edit",
      toString: function () {
        return this.url;
      }
    }